<template>
  <tile
    @click.native="tileClicked"
    v-bind:class="[{ clicked: isActive }]"
  >
    <template v-slot:icon>
      <font-awesome-icon :icon="scene.icon" size="4x" class="text-black-50" />
    </template>

    <template v-slot:line1>
      {{ scene.name }}
    </template>
  </tile>
</template>

<script>
import SceneControlPanel from '@/components/scenes/scene/SceneControlPanel.vue';
import Tile from '@/components/utils/tiles/Tile';
import InvokeSceneMixin from '@/components/scenes/InvokeSceneMixin';

export default {
  name: 'SceneTile',
  mixins: [
    InvokeSceneMixin,
  ],
  components: { Tile },
  props: {
    scene: {
      type: Object,
      required: true,
    },
    editEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isActive: false, // add some delay between scene actiovation + some click animation
    };
  },
  methods: {
    showScenePanel() {
      this.$showPanel({
        component: SceneControlPanel,
        width: '500px',
        cssClass: 'panel-1-custom-class',
        keepAlive: false,
        props: {
          scene: this.scene,
        },
      });
    },
    tileClicked() {
      if (this.editEnabled) {
        if (this.$_.includes(this.scene.permissions, 'w')) {
          this.showScenePanel();
        }
      } else if (!this.isActive && this.$_.includes(this.scene.permissions, 'x')) {
        this.animateTileClick();
        this.invokeScene(this.scene.id);
      }
    },
    animateTileClick() {
      this.isActive = true;
      setTimeout(() => {
        this.isActive = false;
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/assets/scss/settings.scss';

  .tile {
    &:hover .settings-btn {
      display: inline;
    }
    &.clicked {
      background-color: $light;
    }
    .settings-btn {
      display: none;
    }
  }
</style>
